// services/userApiService.ts
import axios from "axios";
import { getCookie } from "../utils/cookieUtils";
import { getGatewayIdToken } from "./gatewaySession";

const userApiBaseUrl = import.meta.env.VITE_USER_API;

const userApi = axios.create({
  baseURL: userApiBaseUrl,
});

userApi.interceptors.request.use(async (config) => {
  const token = getCookie("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${await getGatewayIdToken()}`;
  }
  return config;
});

export const updateUserDetails = async (user: {
  id: string;
  name?: string;
  avatar?: string;
  acceptsTerms?: boolean;
  acceptsPrivacy?: boolean;
}): Promise<void> => {
  try {
    await userApi.post("/api/user/update", {
      id: user.id,
      name: user.name,
      avatar: user.avatar,
      accepts_terms: user.acceptsTerms,
      accepts_privacy: user.acceptsPrivacy,
    });
  } catch (error) {
    console.error("Error updating user details", error);
    throw new Error("Failed to update user details");
  }
};
